const InvoiceWrapper = ({ children }) => {
  return (
    <div className="tm_container">
      <div className="tm_invoice_wrap">
        <div className="tm_invoice tm_style1 tm_type1">
          {children}
        </div>
      </div>
    </div>
  );
};

export default InvoiceWrapper;